import {Directive, HostListener, ElementRef} from '@angular/core';

@Directive({
    selector: '[tabGroupDrag]'
})
export class TabGroupDragDirective {

    startGroupDrag = false;
    lastMouseEvent;

    constructor(private el: ElementRef) {
    }

    @HostListener('mousemove', ['$event']) onMouseMove(event) {
        this.onDragMouseMove(event);
    }

    @HostListener('mousedown', ['$event']) onMouseDown(event) {
        this.onDragMouseDown(event);
    }

    @HostListener('window:mouseup') onMouseUp(event) {
        this.onDragMouseUp();
    }

    private onDragMouseMove(e) {
        if (this.startGroupDrag && this.lastMouseEvent) {
            e.stopImmediatePropagation();
            const diffX = e.clientX - this.lastMouseEvent.clientX;
            if (diffX < -20) {
                this.onDragTab('forward');
            } else if (diffX > 20) {
                this.onDragTab('back');

            }
            if (Math.abs(diffX) > 20) {
                this.lastMouseEvent = e;
            }
        }
    }

    private onDragMouseDown(e) {
        const className = e.target.className;
        if (typeof className === 'string' && (className.indexOf("mdc-tab__text-label") > -1 || className.indexOf("mat-mdc-tab") > -1)) {
            e.stopImmediatePropagation();
            this.startGroupDrag = true;
            this.lastMouseEvent = e;
        }
    }

    private onDragMouseUp() {
        this.startGroupDrag = false;
        this.lastMouseEvent = null;
    }

    private onDragTab(event) {
        if (!event || !this.el) return;
        const children = this.el.nativeElement.children[0].children;
        if (!children || children.length < 2) {
            return;
        }
        if (event === 'forward') {
            const forward = children[2];
            forward.click();
        } else if (event === 'back') {
            const back = children[0];
            back.click();
        }
    }
}
